import styled, { keyframes } from "styled-components";
import { AriaHidden } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { IColors, ITheme } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";

interface GetTopPaddingOptions {
    isPHCallout?: boolean;
    isDealRush?: boolean;
    isGenericDelightPopup?: boolean;
    isJioHotstarFlow?: boolean;
}

const getTopPadding = (theme: ITheme, options: GetTopPaddingOptions = {}) => {
    const { isPHCallout, isDealRush, isGenericDelightPopup, isJioHotstarFlow } = options;
    
    if (isPHCallout || isJioHotstarFlow) {
        return theme?.spacing?.large;
    }
    if (isDealRush) {
        return "36px";
    }
    if (isGenericDelightPopup) {
        return "24px";
    }
    return "40px";
};

const getMarginTop = (theme: ITheme, isDealRush?: boolean, isGenericDelightPopup?: boolean, isJioHotstarFlow?: boolean) => {
    if (isJioHotstarFlow) {
        return theme.spacing.x5;
    }
    if (isDealRush || isGenericDelightPopup) {
        return theme?.spacing?.xxSmall;
    }
    return theme?.spacing?.large;
};

const roundtime = keyframes`
    to {
        transform: scaleX(0);
    }
`;

const DEAL_RUSH_BACKGROUND_IMAGE = "portal/static-assets/icons/dealRush/deal_rush_bg.png";

export const Container = styled.div<{ isDealRush?: boolean; isToingCart?: boolean }>(
    ({ theme, isDealRush, isToingCart }) => ({
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: theme?.cornerRadius?.large,
        background:
            isDealRush && !isToingCart
                ? `url(${getCloudinaryRawUrl(DEAL_RUSH_BACKGROUND_IMAGE)}) center center / cover no-repeat, ${theme?.colors?.[theme.colorMode]?.background_Primary}`
                : theme?.colors?.[theme.colorMode]?.background_Primary,
        minWidth: "260px",
        position: "relative",
        transform: "translate3d(0, 0, 0)",
        overflow: "hidden",
    }),
);

export const ContentContainer = styled(AriaHidden)<{
    isPHCallout?: boolean;
    isDealRush?: boolean;
    isGenericDelightPopup?: boolean;
    isJioHotstarFlow?: boolean;
}>(({ theme, isPHCallout, isDealRush, isGenericDelightPopup, isJioHotstarFlow }) => ({
    padding: `${getTopPadding(theme, { isPHCallout, isDealRush, isGenericDelightPopup, isJioHotstarFlow })} ${theme?.spacing?.medium} ${
        theme?.spacing?.medium
    } ${theme?.spacing?.medium}`,
    textAlign: "center",
}));

export const ImageContainer = styled.div(() => ({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}));
export const SavingsText = styled(Text)<{ isDealRush?: boolean; isGenericDelightPopup?: boolean; isJioHotstarFlow?: boolean }>(
    ({ theme, isDealRush, isGenericDelightPopup, isJioHotstarFlow }) => ({
        marginTop: getMarginTop(theme, isDealRush, isGenericDelightPopup, isJioHotstarFlow),
        color:
            isDealRush || isGenericDelightPopup ? theme?.colors?.[theme.colorMode]?.text_Highest_Emphasis : undefined,
    }),
);

export const SubText = styled(Text)<{ isPHCallout?: boolean; isDealRush?: boolean; ctaColor?: keyof IColors }>(
    ({ theme, isPHCallout, isDealRush, ctaColor }) => ({
        marginTop: isPHCallout || isDealRush ? theme?.spacing?.xxSmall : undefined,
        color: isDealRush && ctaColor ? theme?.colors?.[theme.colorMode]?.[ctaColor] : undefined,
    }),
);

export const StyledGenericIcon = styled(GenericIcon)(({ theme }) => ({
    position: "fixed",
    top: theme?.spacing?.small,
    right: theme?.spacing?.small,
}));

export const UnderUtilisationCallout = styled(Text)<{ isJioHotstarFlow?: boolean }>(({ theme, isJioHotstarFlow }) => ({
    marginTop: !isJioHotstarFlow ?theme?.spacing?.large: "10px",
}));

export const CTAContainer = styled.div<{ isSmallMargin?: boolean; isJioHotstarFlow?: boolean }>(({ theme, isSmallMargin, isJioHotstarFlow }) => ({
    margin: `${theme?.spacing?.[isSmallMargin ? "small" : "xLarge"]} ${theme?.spacing?.medium}`,
    ...(isJioHotstarFlow && {
        marginTop: 0,
        marginBottom: theme?.spacing?.x5,
    })
}));

export const CTAText = styled(Text)<{ ctaColor?: keyof IColors }>(({ theme, ctaColor }) => ({
    textAlign: "center",
    marginBottom: theme?.spacing?.medium,
    color: ctaColor ? theme?.colors?.[theme.colorMode]?.[ctaColor] : undefined,
}));

export const TimeContainer = styled.div<{ ctaColor?: keyof IColors }>`
    height: 6px;
    transform-origin: right center;
    background: ${({ theme, ctaColor }) => theme?.colors?.[theme.colorMode]?.[ctaColor || "primary"]};
    border-radius: ${({ theme }) => theme.cornerRadius.small};
    animation: ${roundtime} 5s linear forwards;
`;

export const Title = styled(Text)<{ isJioHotstarFlow?: boolean }>(({ theme, isJioHotstarFlow }) => ({
    marginTop: !isJioHotstarFlow ? theme?.spacing?.xSmall: 0,
}));
